'use client'

import { CourseCard, CourseCardLink } from '~/components/course-card'
import { Headline } from '~/components/headline'
import { Skeleton } from '~/components/ui/skeleton'
import { useSession } from '~/lib/auth.client'
import INTERVIEW_LEAKS_DATA from '../_static/interview-leaks.json' with { type: 'json', type: 'json', type: 'json' }

export default function Page() {
  const { data: session, isPending } = useSession()

  return (
    <div className="mx-auto my-4 w-full max-w-[calc(100%-2rem)] space-y-6 rounded-2xl bg-gradient-to-br from-muted to-muted/50 px-10 py-10 shadow-sm">
      <div className="space-y-3 border-b border-border/40 pb-6">
        <Headline>Примеры собесов</Headline>
        <p className="text-base text-muted-foreground leading-relaxed">
          Реальные примеры собеседований с подробными разборами вопросов и ответов.
          Изучайте успешные интервью и готовьтесь к своему собеседованию на основе практического опыта.
        </p>
      </div>

      <div className="grid grid-cols-1 items-start gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
        {INTERVIEW_LEAKS_DATA.map((course) => {
          if (isPending) {
            return <Skeleton className="h-[74px] w-full" key={course.pageId} />
          }

          if (session) {
            return (
              <CourseCardLink href={`/plus/interview-leaks/${course.pageId}`} key={course.pageId} title={course.title} />
            )
          }

          return <CourseCard key={course.pageId} {...course} />
        })}
      </div>
    </div>
  )
}
